import daLiJePoljeValidno from "../../../../utils/daLiJePoljeValidno";
import {
  FormControl,
  Input,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { useFormContext } from "react-hook-form";
import { PorukaGreskePolja } from "../../../index";
import { useEffect } from "react";

const Index = ({ nazivPolja, nazivPoljaOpis }: any) => {
  const { register, getValues, setValue, watch } = useFormContext();
  const value = getValues(nazivPolja);
  const valueOpis = watch(nazivPoljaOpis);
  const elektronickeAdrese = getValues("elektronickeAdrese");
  const watchField = watch(nazivPolja);

  useEffect(() => {
    if (elektronickeAdrese && value) {
      setValue(
        nazivPoljaOpis,
        elektronickeAdrese.find((adresa: any) => adresa.id === value).opis
      );
    }
  }, [value]);

  return (
    <>
      <FormControl fullWidth error={!daLiJePoljeValidno(nazivPolja)}>
        <InputLabel htmlFor={nazivPolja}>*Tip adrese (Address type)</InputLabel>
        <Select
          labelId={nazivPolja}
          id={nazivPolja}
          value={value}
          label={`*Tip adrese (Address type)`}
          variant={"standard"}
          {...register(nazivPolja)}
          onChange={(e: SelectChangeEvent<any>) => {
            setValue(nazivPolja, e.target.value);
            setValue(
              nazivPoljaOpis,
              elektronickeAdrese.filter(
                (adresa: any) => adresa.id === e.target.value
              ).opis
            );
          }}
        >
          {elektronickeAdrese.map(
            (adresa: any, key: number) =>
              adresa.id !== 1 && (
                <MenuItem key={key} value={adresa.id}>
                  {adresa.opis}
                </MenuItem>
              )
          )}
        </Select>
        <PorukaGreskePolja nazivPolja={nazivPolja} />
      </FormControl>
      <Input type={"hidden"} value={valueOpis} {...register(nazivPoljaOpis)} />
    </>
  );
};

export default Index;
